'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconArrowURight, iconArrowURightTag } from '@ni/nimble-components/dist/esm/icons/arrow-u-right';
import { wrap } from '../../utilities/react-wrapper';

export type { IconArrowURight };
export { iconArrowURightTag };
export const NimbleIconArrowURight = wrap(IconArrowURight);